import $ from "jquery"
import "slick-carousel-latest"
import Rellax from '../../../../node_modules/rellax/rellax.min.js';

var rellaxElement = $('.js-parallax-rellax');

var rellax = new Rellax('.js-parallax-rellax', {
    center: true,
    breakpoints:[480, 768, 1201]
});

$(window).on('load', function(){
    if(rellaxElement.length){
        rellax.refresh();
    }
});

function sliderParallaxThumbnailInit() {
    var $slickParallaxElement = $('.js-parallax-thumbnail-slider');

    $slickParallaxElement.each(function() {
        var $sliderParent = $(this).parent();

        $(this).slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.js-parallax-main-slider',
            dots: false,
            arrows: true,
            vertical: true,
            focusOnSelect: true,
            verticalSwiping: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        vertical: false,
                        swipeToSlide: true,
                        verticalSwiping: false
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        vertical: false,
                        swipeToSlide: true,
                        verticalSwiping: false
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        vertical: false,
                        arrows: false,
                        dots: true,
                        swipeToSlide: true,
                        verticalSwiping: false
                    }
                }
            ]
        });

        if ($(this).find('.item').length > 1) {
            $(this).siblings('.js-parallax-counter').show();
        }

        $(this).on('afterChange', function(event, slick, currentSlide){
            $sliderParent.find('.js-parallax-counter .js-parallax-counter-active').html(currentSlide + 1);
            history.pushState({}, '',  '#' + $('.js-parallax-thumbnail-slider .slick-slide.slick-active .parallax__thumbnail-item').data('anchor'));
            
            if(rellaxElement.length){
                rellax.refresh();
            }
        });

        var sliderItemsNum = $(this).find('.slick-slide').not('.slick-cloned').length;
        $sliderParent.find('.js-parallax-counter .js-parallax-counter-total').html(sliderItemsNum);

    });
};

$('.js-parallax-main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.js-parallax-thumbnail-slider',
    dots: false,
    arrows: false,
    fade: true,
    cssEase: 'linear'
});

if(rellaxElement.length){
    $('.js-parallax-thumbnail-slider, .js-parallax-main-slider').on('afterChange beforeChange', function(event, slick, currentSlide){
        rellax.refresh();
    });
}

sliderParallaxThumbnailInit();

/* Hash and scroll on section script **/
const hashParallax = window.location.hash.substring(1);
const titleParallax = $(".js-parallax-thumbnail-slider .parallax__thumbnail-item[data-anchor='" + hashParallax + "']");

$(window).on('load', function() {
    if(hashParallax && titleParallax.length) {
        $('html, body').animate({
            scrollTop: $('#ourwork').offset().top
        }, 0);

        titleParallax.closest('.slick-slide').trigger('click');
    }
});

/**
 * Scripts for parallax section padding left
 */

function calculatePaddingParallax(){
    var statsDistanceBase = $('.js-padding-parallax-base');
    var statsDistance;

    if(statsDistanceBase.length){
        var statsDistance = $(window).width() - (statsDistanceBase.offset().left + statsDistanceBase.outerWidth());
    }

    $('.js-parallax-inner').css('padding-left', statsDistance + 'px');
}

calculatePaddingParallax();

$(window).on('resize', function(){
    calculatePaddingParallax();
});